import React, { useState, useEffect } from "react";
import { Space } from "antd";
import "../../../style/sample.css";
import { toPrice } from "../../../helpers/stringFormat";
import TransactionTableFilters from "./transactionTableFilters";
// import GenericTableOnRowOnClick from "../../tables/genericTableOnRowOnClick";
import moment from "moment";
import TransactionsDrawerSimple from "./transactionsDrawerSimple";
import GenericTableOnRowOnClick1 from "../../tables/genericTableOnRowOnClick1";
import { gridDateComparator } from '@mui/x-data-grid';

const CanceledTransactions = (props) => {
    const [showTxns, setShowTxns] = useState(props.transactions);
    const [selectedTransactionData, setSelectedTransactionData] = useState(null);
    const [dateRangeFilter, setDateRangeFilter] = useState(null);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);

    useEffect(() => {
        setShowTxns(props.transactions);
    }, [props.transactions]);

    const handleExpand = (expanded, record) => {
        if (expanded) {
            setExpandedRowKeys([record.id]);
            setSelectedTransactionData({
                "CREATED AT": moment(record.attributes.createdAt).format("MMMM Do, YYYY"),
                "TYPE": record.type,
                "ACCOUNT NUMBER": record.attributes.counterparty ? record.attributes.counterparty.accountNumber : "",
                "ROUTING NUMBER": record.attributes.counterparty ? record.attributes.counterparty.routingNumber : "",
            });
        } else {
            setExpandedRowKeys([]);
        }
    };

    const handleSearch = (e) => {
        const searchText = e.target.value.toLowerCase();

        if (searchText === "") {
            setShowTxns(props.transactions);
            return;
        }

        const data = props.transactions || [];
        const filteredData = data.filter((txn) => {
            const propName1 = txn.type && txn.type.toLowerCase().includes('ach')
                ? txn.relationships?.counterparty?.data?.name || ""
                : txn.attributes?.counterparty?.name || "";

            const propName2 = txn.attributes?.description || "";
            const propName3 = txn.type || "";

            return (
                propName1.toLowerCase().includes(searchText) ||
                propName2.toLowerCase().includes(searchText) ||
                propName3.toLowerCase().includes(searchText)
            );
        });

        setShowTxns(filteredData);
    };


    const handleDateFilter = (value) => {
        if (value && value.length === 2) {
            setDateRangeFilter(value);
            const start_date = value[0].format("YYYY-MM-DD");
            const end_date = value[1].format("YYYY-MM-DD");
            const resData = props.transactions.filter((data) => {
                const txn_date = data.attributes.createdAt.split(" ")[0];
                return txn_date >= start_date && txn_date <= end_date;
            });
            setShowTxns(resData);
        } else {
            setShowTxns(props.transactions);
        }
    };

    const table_columns = [
        {
            field: 'createdAt',
            headerName: 'Date',
            flex: 1.5,
            sortable: true,
            renderCell: (params) => {
                const date = params?.row?.attributes?.createdAt;
                return <span>{date?.slice(0, 10) || 'N/A'}</span>;
            },
            valueGetter: (params) => {
                const date = params?.row?.attributes?.createdAt;
                if (!date) return null;
                return date
            },
            sortComparator: (v1, v2) => {
                if (!v1) return 1;
                if (!v2) return -1;
                const date1 = new Date(v1).getTime();
                const date2 = new Date(v2).getTime();
                return date2 - date1;
            },
        },
        {
            field: 'counterparty_name',
            headerName: 'To/From',
            flex: 1.5,
            sortable: true,
            sortComparator: (a, b) => (b || '').toLowerCase().localeCompare((a || '').toLowerCase()),
            valueGetter: (params) => {
                const row = params?.row;
                const originType = row?.type?.startsWith("Originated");
                return originType
                    ? row?.attributes?.counterparty?.name || row?.counterparty_name || ''
                    : row?.relationships?.counterparty?.data?.name || row?.counterparty_name || '';
            },
            renderCell: (params) => (
                <p style={{ textTransform: 'capitalize' }}>
                    {params?.row?.type?.startsWith("Originated")
                        ? params?.row?.attributes?.counterparty?.name || params?.row?.counterparty_name || ''
                        : params?.row?.relationships?.counterparty?.data?.name || params?.row?.counterparty_name || ''}
                </p>
            ),
        },
        {
            field: 'description',
            headerName: 'Description',
            flex: 3,
            sortable: true,
            valueGetter: (params) => {
                const description = params?.row?.attributes?.description || '';
                const reason = params?.row?.attributes?.reason || '';
                return `${description} - ${reason}` || '';
            },
            sortComparator: (a, b) => (b || '').toLowerCase().localeCompare((a || '').toLowerCase()),
            renderCell: (params) => (
                <p style={{ textTransform: 'capitalize' }}>
                    {params?.row?.attributes?.description || ''} - {params?.row?.attributes?.reason || ''}
                </p>
            ),
        },
        {
            field: 'amount',
            headerName: 'Amount',
            flex: 1.5,
            sortable: true,
            // align: 'right',
            valueGetter: (params) => params?.row?.attributes?.amount || 0,
            sortComparator: (a, b) => (b || 0) - (a || 0),
            renderCell: (params) => (
                <span>{toPrice(params?.row?.attributes?.amount || 0)}</span>
            ),
        },
    ];



    // const table_columns = [
    //     {`
    //         title: "Date",
    //         dataIndex: "timestamp",
    //         width: "15%",
    //         render: (text, record) => <span>{record.attributes?.createdAt?.slice(0, 10)}</span>,
    //         defaultSortOrder: "descend",
    //         sorter: (a, b) => a.attributes?.createdAt?.localeCompare(b.attributes?.createdAt),
    //     },
    //     {
    //         title: 'To/From',
    //         width: '15%',
    //         render: (_, record) => (
    //             record.type && record.type.startsWith("Originated") ? (
    //                 <p style={{ textTransform: 'capitalize' }}>
    //                     {record.attributes?.counterparty?.name || record.counterparty_name}
    //                 </p>
    //             ) : (
    //                 <p style={{ textTransform: 'capitalize' }}>
    //                     {record.relationships?.counterparty?.data?.name || record.counterparty_name}
    //                 </p>
    //             )
    //         ),
    //         sorter: (a, b) => {
    //             const getCounterpartyName = (record) => {
    //                 if (record.type?.startsWith("Originated")) {
    //                     return record.attributes?.counterparty?.name || record.counterparty_name || '';
    //                 } else {
    //                     return record.relationships?.counterparty?.data?.name || record.counterparty_name || '';
    //                 }
    //             };

    //             const nameA = getCounterpartyName(a).toLowerCase();
    //             const nameB = getCounterpartyName(b).toLowerCase();

    //             return nameA.localeCompare(nameB);
    //         },
    //     },
    //     {
    //         title: "Description",
    //         width: "40%",
    //         render: (_, record) => (
    //             <p style={{ textTransform: "capitalize" }}>
    //                 {record.attributes?.description} - {record.attributes?.reason}
    //             </p>
    //         ),
    //     },
    //     {
    //         title: "Amount",
    //         width: "15%",
    //         align: "right",
    //         render: (_, record) => (
    //             <span style={{ color: "" }}>
    //                 {toPrice(record.attributes?.amount)}
    //             </span>
    //         ),
    //     },
    // ];

    const totalTableWidth = table_columns.reduce((totalWidth, column) => {
        return totalWidth + parseFloat(column.width || 0);
    }, 0);

    const firstColumnWidthFraction = parseFloat(table_columns[0].width || 0) / totalTableWidth;
    const expandableOffset = Math.ceil(firstColumnWidthFraction * 100);

    const expandableConfig = {
        expandedRowRender: (record) =>
            <TransactionsDrawerSimple
                selectedTransactionData={selectedTransactionData}
                offset={expandableOffset}
            />,
        expandRowByClick: true,
        onExpand: handleExpand,
        expandedRowKeys: expandedRowKeys,
        expandIconColumnIndex: -1,
    };

    let exportdata = [];
    for (var i = 0; i < showTxns.length; i++) {
        var item = showTxns[i];
        var data = {
            Date: item.attributes.createdAt.split(" ")[0],
            Description: item.attributes.description,
            Method: item.type,
            "To/From": item.counterparty_name,
            Amount:
                item.attributes.amount >= 0
                    ? `$${parseFloat(item.attributes.amount).toFixed(2)}`
                    : `- $${parseFloat(
                        Math.abs(item.attributes.amount)
                    ).toFixed(2)}`,
        };
        exportdata.push(data);
    }

    const TransactionDrawerX = () => (<TransactionsDrawerSimple
        selectedTransactionData={selectedTransactionData}
    />)

    return (
        <Space direction="vertical" style={{ width: "100%" }}>
            {/*  Table Filters */}
            <TransactionTableFilters
                handleSearch={handleSearch}
                handleDateFilter={handleDateFilter}
                dateRangeFilter={dateRangeFilter}
                bankAccountName={props.bankAccountName}
                exportdata={exportdata}
            />
            <GenericTableOnRowOnClick1
                pagination={{
                    paginationModel: { pageSize: showTxns?.length || 10, page: 0 },
                }}
                pageSizeOptions={[5, 10, 25]}
                columns={table_columns}
                dataSource={showTxns}
                sortModel={[
                    {
                        field: "createdAt",
                        sort: "desc",
                    },
                ]}
                enableExpandable={true}
                numerator={props.numerator}
                denominator={props.denominator}
                handleExpand={handleExpand}
                transactionDrawerComponent={TransactionDrawerX}
                style={{ cursor: "pointer" }}
                loading={props.loadingIncompleteTransactions}
            />
            {/* <GenericTableOnRowOnClick
                pagination={{
                    className: "card-table-pagination",
                    defaultPageSize: 50,
                    showSizeChanger: true,
                }}
                columns={table_columns}
                dataSource={showTxns}
                expandableConfig={expandableConfig}
                style={{ cursor: "pointer" }}
                loading={props.loadingIncompleteTransactions}
            /> */}
        </Space>
    );
};

export default CanceledTransactions;